import "./styles.css";
import Effect from "./pages/home/page";

export function GoldLiquidHero() {
  return (
    <div className="special-effect-root" data-special-effect="gold-liquid">
      <Effect />
    </div>
  );
}

export default GoldLiquidHero;
